const ko_KR = {
  message : {
    welcomeMessage : '안녕하세요! 네이버 클라우드 플랫폼의 데이터 센터에 오신 것을 환영합니다.',
    welcome1 : '환영합니다.',
  },
  label: {
    selectIdc: 'IDC 선택',
    tosAgree: '약관동의',
    inOutInput: '출입정보입력',
    inOutCheck: '출입정보확인',
    enterTicket: '출입티켓 선택',
    secAgree : '보안서약서 동의',
    inOutCheckList : '출입 체크리스트 확인',
    enterInfo : '입실정보 확인',
    empInfo : '담당직원정보',
    empInfoDesc: '인증완료된 출입담당 임직원 정보입니다.(변경불가)',
    visitorInfoInput: '방문 요청 신청자 정보 입력',
    visitorInfoInputDesc: '이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요.',
    extraInfoInput: '추가 방문자 정보 입력',
    extraInfoInputDesc: '이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요.',
    visitDateAndSubject: '출입예정일 및 목적',
    visitDateAndSubjectDesc: '출입 기간과 방문 목적을 입력하세요.',
    etcInfo: '선택정보 입력',
    etcInfoDesc: '화물용 엘레베이터 사용 여부 및 기타 요청사항을 입력하세요',
  },
  formLabel : {
    category: '항목',
    manufacturer: '제조사',
    modelName: '모델명',
    serialNo: '시리얼 번호',
    etc: '비고',
  },
  button:{
    add: '추가'
  },
  error: {
    visitError: '임직원 정보를 확인하세요.',
    visitEmpError: '다른 임직원 정보로 출입 신청 할 수 없습니다.',
    addAssetError: '반입자산 정보를 확인해주세요.',
    addVisitorError: '방문자 등록을 실패했습니다. 확인해주세요.',
  }
}
export default ko_KR;
